import React, { Component } from 'react';
import {
  formatPercent,
  formatTextFloat,
  formatChange,
} from '../../../../helpers/Text';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { getColor, getTimeRange } from '../helper';
import Status from './Status';
import moment from 'moment';

class VnMarket extends Component {
  getTimeRange = () => {
    const { dailyDate: endDate, data } = this.props;
    const startDate = moment(Object.values(data)[0].tradingDate).format('l');

    return `(${startDate} - ${endDate})`;
  };

  getValue = () => {
    const { data } = this.props;
    var arr = Object.values(data);

    return arr.reduce((total, item) => {
      return total + item.indexChange > 0 ? 1 : -1;
    }, 0);
  };

  getClassName = value => {
    return value > 0
      ? 'text-increase index-change'
      : 'text-decrease index-change';
  };

  render() {
    let { data, className, dailyDate } = this.props;
    const i18nKey = 'marketInDepthProspect.prospectItem';
    const prospectName = I18n.t(`${i18nKey}.vnMarket`);
    className = [className, 'prospect-item flip-container vertical'].join(' ');

    const value = this.getValue();

    return (
      <div
        className={className}
        style={{
          backgroundColor: getColor(value),
        }}
      >
        <div className="flipper">
          <div className="prospect-no-hover front">
            {/* Name */}
            <div className="prospect-item__title">
              <span>{prospectName}</span>
            </div>

            <Status value={data.vnIndex.indexValue} />
          </div>

          <div className="prospect-item-hover back">
            <div className="prospect-item__title">
              <span>{prospectName}</span>
              <span className="ml-5 time-range">
                {this.getTimeRange(dailyDate, data)}
              </span>
            </div>

            <div className="prospect-item__content">
              <div className="prospect-item__row">
                <span className="label">{I18n.t(`${i18nKey}.vnIndex`)}</span>
                <strong>
                  {`${formatTextFloat(data.vnIndex.indexValue)} `}
                  <span className={this.getClassName(data.vnIndex.indexChange)}>
                    (
                    {`${formatChange(
                      formatTextFloat(data.vnIndex.indexChange),
                    )} ~ ${formatTextFloat(
                      formatPercent(data.vnIndex.percentIndexChange),
                    )}%`}
                    )
                  </span>
                </strong>
              </div>

              <div className="prospect-item__row">
                <span className="label">{I18n.t(`${i18nKey}.vn30`)}</span>
                <strong>
                  {`${formatTextFloat(data.vn30.indexValue)} `}
                  <span className={this.getClassName(data.vn30.indexChange)}>
                    (
                    {`${formatChange(
                      formatTextFloat(data.vn30.indexChange),
                    )} ~ ${formatTextFloat(
                      formatPercent(data.vn30.percentIndexChange),
                    )}%`}
                    )
                  </span>
                </strong>
              </div>

              <div className="prospect-item__row">
                <span className="label">{I18n.t(`${i18nKey}.hnxIndex`)}</span>
                <strong>
                  {`${formatTextFloat(data.hnxIndex.indexValue)} `}
                  <span
                    className={this.getClassName(data.hnxIndex.indexChange)}
                  >
                    (
                    {`${formatChange(
                      formatTextFloat(data.hnxIndex.indexChange),
                    )} ~ ${formatTextFloat(
                      formatPercent(data.hnxIndex.percentIndexChange),
                    )}%`}
                    )
                  </span>
                </strong>
              </div>

              <div className="prospect-item__row">
                <span className="label">{I18n.t(`${i18nKey}.hnx30`)}</span>
                <strong>
                  {`${formatTextFloat(data.hnx30.indexValue)} `}
                  <span className={this.getClassName(data.hnx30.indexChange)}>
                    (
                    {`${formatChange(
                      formatTextFloat(data.hnx30.indexChange),
                    )} ~ ${formatTextFloat(
                      formatPercent(data.hnx30.percentIndexChange),
                    )}%`}
                    )
                  </span>
                </strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  i18n: state.i18n,
});

export default connect(mapStateToProps)(VnMarket);
